import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SharedPipesModule } from '@reconcept-platform/shared/util';

@Component({
  selector: 'rcp-file-preview-iframe',
  styleUrls: ['./file-preview-iframe.component.scss'],
  template: ` <iframe [src]="previewFileURL | safeSrc"></iframe> `,
  imports: [SharedPipesModule],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class FilePreviewIframeComponent {
  @Input()
  previewFileURL: string;
}
